import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import SortDirectionArrow from './SortDirectionArrow'
import css from '../styles.css'

const HeaderCell = ({ label, colName, cssClass, handleSortThenFetchPatients, active, asc }) => {
  const headerCellClasses = cx(css.headerCell,
    cssClass,
    { active, [css.headerCell_nosort]: !handleSortThenFetchPatients })
  return (
    <div
      className={headerCellClasses}
      data-column={colName}
      onClick={handleSortThenFetchPatients}
    >
      <span>{label}</span>
      {active && <SortDirectionArrow asc={asc} />}
    </div>
  )
}

HeaderCell.propTypes = {
  label: PropTypes.string.isRequired,
  colName: PropTypes.string,
  cssClass: PropTypes.string.isRequired,
  handleSortThenFetchPatients: PropTypes.func,
  active: PropTypes.bool,
  asc: PropTypes.bool,
}

export default HeaderCell



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/Header/HeaderCell.js